import _, { camelCase } from "lodash";
import { Types } from "./pensionIntegrationActions";

const pensionIntegrationReducers = (state, action) => {
	switch (action.type) {
		case Types.PENSION_INTEGRATION_POLL_ACTION_MODAL: {
			let newState = _.cloneDeep(state);

			const integration = camelCase(action.integration);

			if (action.poll) {
				newState.integration.pension[integration].pollActionModal = action.poll;
			} else {
				delete newState.integration.pension[integration].pollActionModal;
			}

			return newState;
		}
		case Types.PENSION_INTEGRATION_UPDATE_PAY_PERIOD: {
			let newState = _.cloneDeep(state);
			const { payPeriods } = newState.integration?.pension?.[action.integration] || {};

			const period = action.period;

			const updatedPayPeriods = (() => {
				const existingPayPeriod = payPeriods.find((p) => p.payPeriodId === period.payPeriodId);

				if (existingPayPeriod) {
					return payPeriods.map((p) => (p.payPeriodId === period.payPeriodId ? period : p));
				} else {
					return [...payPeriods, period];
				}
			})();

			newState.integration.pension = {
				...newState.integration?.pension,
				[action.integration]: {
					...newState.integration?.pension?.[action.integration],
					payPeriods: updatedPayPeriods,
				},
			};

			return newState;
		}
		case Types.PENSION_INTEGRATION_PUSH_POLL_LIST: {
			let newState = _.cloneDeep(state);

			const integration = camelCase(action.integration);
			const list = newState.integration.pension[integration].onGoingPolls || [];

			const newPoll = action.poll;
			const existingIndex = list.findIndex((poll) => poll.id == newPoll.id);

			if (existingIndex > -1) {
				// replace the poll at that index
				list[existingIndex] = newPoll;
			} else {
				list.push(newPoll);
			}

			newState.integration.pension[integration].onGoingPolls = list;

			return newState;
		}
		case Types.PENSION_INTEGRATION_SET_POLL_LIST: {
			let newState = _.cloneDeep(state);

			const integration = camelCase(action.integration);

			newState.integration.pension[integration].onGoingPolls = action.polls;

			return newState;
		}
		case Types.PENSION_INTEGRATION_SENDING_PAY_PERIOD: {
			let newState = _.cloneDeep(state);

			const sending = newState.integration?.pension?.[action.integration]?.sendingPayroll;

			let sendingPayroll = [...(Array.isArray(sending) ? sending : [])];

			if (action.status) {
				sendingPayroll.push(action.periodId);
			} else {
				sendingPayroll = sendingPayroll?.filter((item) => item != action.periodId);
			}

			newState.integration.pension = {
				...newState.integration?.pension,
				[action.integration]: {
					...newState.integration?.pension?.[action.integration],
					sendingPayroll,
				},
			};

			return newState;
		}
		case Types.PENSION_INTEGRATION_SYNCING_STATUS: {
			let newState = _.cloneDeep(state);

			if (action.unsyncedEmployees) {
				newState.integration.pension[action.integration].unsyncedEmployees = action.unsyncedEmployees;
			}
			if (action.error) {
				newState.integration.pension[action.integration].syncError = action.error;
			}
			if (action.syncingStatus) {
				newState.integration.pension[action.integration].syncingStatus = action.syncingStatus;
			}
			return newState;
		}
		case Types.PENSION_INTEGRATION_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);

			if (!newState.integration.pension[action.integration].details) {
				newState.integration.pension[action.integration].details = {};
			} else {
				newState.integration.pension[action.integration].details = {
					...newState.integration.pension[action.integration].details,
				};
			}

			newState.integration.pension[action.integration].details[action.field] = action.value;
			return newState;
		}

		case Types.PENSION_INTEGRATION_SAVING: {
			let newState = _.cloneDeep(state);

			newState.integration.pension[action.integration] = {
				...(newState.integration.pension[action.integration] ?? {}),
				saving: true,
			};

			return newState;
		}
		case Types.PENSION_INTEGRATION_SAVE: {
			let newState = _.cloneDeep(state);

			newState.integration.pension[action.integration] = {
				...(newState.integration.pension[action.integration] ?? {}),
				...action.data,
				saving: false,
			};

			return newState;
		}
		case Types.PENSION_INTEGRATION_PENSION_STAGE: {
			let newState = _.cloneDeep(state);

			newState.integration.pension[action.integration].stage = action.stage;

			return newState;
		}
		case Types.PENSION_INTEGRATION_COMPANIES: {
			let newState = _.cloneDeep(state);

			newState.integration.pension[action.integration].companies = action.companies;

			return newState;
		}
		case Types.PENSION_INTEGRATION_ACCOUNTS: {
			let newState = _.cloneDeep(state);

			newState.integration.pension[action.integration].accounts = action.accounts;

			return newState;
		}
		case Types.PENSION_INTEGRATION_PAY_PERIOD: {
			let newState = _.cloneDeep(state);

			const index = newState?.payPeriods?.periods?.map((period) => period.id).indexOf(action.payPeriodId);

			if (action.pensionIntegrationId) {
				if (newState.payPeriods.periods) {
					newState.payPeriods.periods[index].pensionIntegrationId = action.pensionIntegrationId;
				}
				if (
					newState.payroll?.payPeriodDetails?.id == action.payPeriodId &&
					!newState.payroll.payPeriodDetails.pensionIntegrationId
				) {
					newState.payroll.payPeriodDetails.pensionIntegrationId = action.pensionIntegrationId;
				}
			}
			if (action.pensionIntegrationStatus) {
				if (newState.payPeriods.periods) {
					newState.payPeriods.periods[index].pensionIntegrationStatus = action.pensionIntegrationStatus;
				}
				if (newState.payroll?.payPeriodDetails?.id == action.payPeriodId) {
					newState.payroll.payPeriodDetails.pensionIntegrationStatus = action.pensionIntegrationStatus;
				}
			}

			return newState;
		}

		default:
			return state;
	}
};

export default pensionIntegrationReducers;
